import '../styles/main.scss';
import Swiper from './modules/swiper.min.js';
import LazyLoad from './modules/lazyLoad';
import Menu from './modules/Menu';
import Datepicker from './modules/Datepicker';
import ContactPage from './pages/ContactPage';

const sliderInit = () => {
  let heroSlider = new Swiper('.hero__container', {
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
  });

  let facilitiesSlider = new Swiper('.block1__container', {
    slidesPerView: 5,
    spaceBetween: 40,
    centeredSlides: true,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.block1__controls--next',
      prevEl: '.block1__controls--prev',
    },
    breakpoints: {
      1600: { slidesPerView: 4, spaceBetween: 20, },
      1200: { slidesPerView: 3, spaceBetween: 20, },
      860: { slidesPerView: 2, spaceBetween: 10, },
      570: { slidesPerView: 1, spaceBetween: 10, }
    },
  });

  let hotelOptions = [
    {
      selector: '.h-hotel01',
      nextEl: '.block6__controls--next-1',
      prevEl: '.block6__controls--prev-1'
    },
    {
      selector: '.h-hotel02',
      nextEl: '.block6__controls--next-2',
      prevEl: '.block6__controls--prev-2'
    },
    {
      selector: '.h-hotel03',
      nextEl: '.block6__controls--next-3',
      prevEl: '.block6__controls--prev-3'
    },
    {
      selector: '.h-hotel04',
      nextEl: '.block6__controls--next-4',
      prevEl: '.block6__controls--prev-4'
    },
    {
      selector: '.h-hotel05',
      nextEl: '.block6__controls--next-5',
      prevEl: '.block6__controls--prev-5'
    },
    {
      selector: '.h-hotel06',
      nextEl: '.block6__controls--next-6',
      prevEl: '.block6__controls--prev-6'
    },
    {
      selector: '.h-hotel07',
      nextEl: '.block6__controls--next-7',
      prevEl: '.block6__controls--prev-7'
    },
  ];

  hotelOptions.map(x => {
    new Swiper(x.selector, {
      loop: true,
      pagination: { el: '.swiper-pagination', },
      navigation: {nextEl: x.nextEl, prevEl: x.prevEl}
    });
  });
}

const lazyLoadInit = () => {
  let heroImages = new LazyLoad({lazyImages: '.hero__slide'});
  let conceptImages = new LazyLoad({lazyImages: '.c-intro__image'});
  let conceptBackgrounds = new LazyLoad({lazyImages: '.block3__image'});
}

window.onload = () => {
  document.body.classList.remove('loading');

  sliderInit();
  lazyLoadInit();

  new Menu();
  new ContactPage();
  new Datepicker();
}
